const ITEMS = [
  "Furniture Assembly",
  "TV Mounting",
  "Moving Help",
  "Gardening",
  "Cleaning",
  "Shelves & Mirrors",
  "Beds & Wardrobes",
  "Handyman",
  "Home Services",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="services-marquee"
      className="relative bg-navy py-6 overflow-hidden -rotate-1 scale-[1.02] my-4"
    >
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-bold text-white/90 text-xl sm:text-2xl tracking-tight px-6">
              {item}
            </span>
            <span className="text-teal-light text-lg">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
